import { runInAction } from 'mobx';
import { configurationSettings } from '../../../../../configuration/configuration-settings';
import { LoyaltyAuthenticationType } from '../../../../../configuration/types/loyalty/loyalty-authentication-type';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
/**
 * Updates the `isMemberSignedIn` state based on the state of an [[MemberAuthenticationToken]] provided by the
 * `authToken` parameter or the `getToken` callback.
 */
export const updateIsMemberSignedInFromToken = async (authToken) => {
    const { authentication } = configurationSettings.data.loyalty;
    if (authentication.type !== LoyaltyAuthenticationType.Token)
        return;
    let token;
    if (authToken) {
        await authentication.setToken(authToken);
        token = authToken;
    }
    else {
        token = await authentication.getToken();
    }
    runInAction(() => {
        temporaryLoyaltyDomainStore.data.isMemberSignedIn = !!token;
    });
};
